<template>
    <label
        :class="[
            isMobile && isReview ? 'cz2__btn--flat' : 'cz2__btn--black',
        ]"
        class="cz2__btn cz2__cursor-pointer"
    >
        {{ buttonCopy }}

        <beta-badge
            v-if="aiActiveState === aiStates.default"
            :is-in-button="true"
        />

        <input
            name="aiUpload"
            type="file"
            :accept="fileTypes"
            @input="handleInput"
            class="hide"
        />
    </label>
</template>

<script>
    import BetaBadge from './BetaBadge.vue';

    export default {
        components: {
            BetaBadge,
        },

        props: {
            isReview: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                file: null,
                fileTypes: '.jpg,.png,.gif,.tiff,.heic,.heif',
                allowedTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/heic', 'image/heif'],
                allowedExtensions: ['.jpg', '.jpeg', '.png', '.gif', '.heic', '.heif'],
            };
        },

        computed: {
            aiUploadStates() {
                return this.$store.state.aiUploadStates;
            },

            aiStates() {
                return this.$store.state.aiStates;
            },

            aiActiveState() {
                return this.$store.state.aiActiveState;
            },

            buttonCopy() {
                return this.isReview ? this.$t('AI_UPLOAD_NEW') : this.$t('AI_UPLOAD');
            },

            isMobile() {
                return this.$store.state.customizer.isMobile;
            },
        },

        methods: {
            handleInput(event) {
                this.openUploadState();

                // eslint-disable-next-line
                this.file = event.target.files[0];

                this.validateFile();
            },

            openUploadState() {
                this.$store.dispatch('setAiActiveState', this.aiStates.upload);
                this.$store.dispatch('setAiUploadActiveState', this.aiUploadStates.loading);
                this.$store.dispatch('resetAiStates');
            },

            validateFile() {
                this.$store.state.customizer.mainController.trackAction({
                    action: 'ai-selfie-upload',
                });

                // Check file type
                if (!this.allowedTypes.includes(this.file.type)) {
                    // Fallback for cases where browser reports different MIME type for HEIC
                    if (this.file.type === '' && !this.allowedExtensions.some((ext) => this.file.name.toLowerCase().endsWith(ext))) {
                        setTimeout(() => {
                            this.$store.dispatch('setAiMatchError', 'file-type');
                            this.$store.dispatch('setAiUploadActiveState', this.aiUploadStates.error);
                        }, 100);

                        return;
                    }
                }

                // Check file extension
                const fileExtension = `.${this.file.name.split('.').pop().toLowerCase()}`;

                if (!this.allowedExtensions.includes(fileExtension)) {
                    setTimeout(() => {
                        this.$store.dispatch('setAiMatchError', 'file-type');
                        this.$store.dispatch('setAiUploadActiveState', this.aiUploadStates.error);
                    }, 100);

                    return;
                }

                // Check file size
                const fileSize = this.file?.size;
                const maxFileSize = 20 * 1024 * 1024; // 20 MB

                if (fileSize > maxFileSize) {
                    setTimeout(() => {
                        this.$store.dispatch('setAiMatchError', 'file-size');
                        this.$store.dispatch('setAiUploadActiveState', this.aiUploadStates.error);
                    }, 100);

                    return;
                }

                const reader = new FileReader();

                reader.onload = (e) => {
                    // Determine image orientation for proper display in the review screen.
                    const img = new Image();
                    let orientation = 'portrait';

                    if (fileExtension !== '.heic' && fileExtension !== '.heif') {
                        img.onload = () => {
                            if (img.naturalWidth > img.naturalHeight && img.naturalWidth - img.naturalHeight > 40) {
                                orientation = 'landscape';
                            } else if (img.naturalWidth < img.naturalHeight && img.naturalHeight - img.naturalWidth > 40) {
                                orientation = 'portrait';
                            } else {
                                orientation = 'square';
                            }

                            this.processImage(e.target.result, orientation);
                        };
                    } else {
                        this.processImage(e.target.result, 'portrait');
                    }

                    img.src = e.target.result;
                };

                reader.readAsDataURL(this.file);
            },

            processImage(imageData, imageOrientation) {
                this.$store.dispatch('globalBusy', true);

                this.$store.dispatch('setAiPreview', {
                    sourceImage: imageData,
                    orientation: imageOrientation,
                }).then(() => {
                    this.$store.dispatch('setAiUploadActiveState', this.aiUploadStates.review);
                });
            },
        },
    };
</script>
